import { ref } from 'vue'
import { useLogger } from '@booksy-com/vue-tools'

export function useUrlBuilder (initialValue) {
  const src = ref(initialValue)
  const logger = useLogger('url-builder')

  const removeTrailingSlash = function () {
    if (!src.value) {
      return this
    }

    src.value = src.value.replace(/\/+$/, '')

    return this
  }

  const addLocalize = function ({ country, language } = {}) {
    if (!country || !language) {
      logger.warn('localize param is not defined')
      return this
    }

    src.value += `/${encodeURIComponent(language)}-${encodeURIComponent(country)}/`

    return this
  }

  const addPath = function (path) {
    if (!path) {
      logger.warn('path is not defined')
      return this
    }

    const hasTrailingSlash = src.value[src.value.length - 1] === '/'

    if (hasTrailingSlash) {
      removeTrailingSlash()
    }

    src.value += String(path)
      .split('/')
      .reduce((acc, part) => {
        if (!part?.trim()?.length) {
          return acc
        }

        acc += `/${encodeURIComponent(part)}`
        return acc
      }, '')

    return this
  }

  const addQueryObject = function (query) {
    if (!query) {
      logger.warn('query is not defined')
      return this
    }

    if (!Object.keys(query).length) {
      logger.info('empty query object provided')
      return this
    }

    const hasSrcQueryParams = src.value.includes('?')
    const queryString = new URLSearchParams(query).toString()

    src.value += hasSrcQueryParams ? `&${queryString}` : `?${queryString}`

    return this
  }

  const build = () => {
    const value = src.value
    src.value = initialValue

    return value
  }

  return {
    addLocalize,
    removeTrailingSlash,
    addPath,
    build,
    addQueryObject,
  }
}
